module.exports = __webpack_public_path__ + "5da67061b6caf3383a1716607ca44056.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/9_G#2.mp3
// module id = 84
// module chunks = 0